export default __webpack_public_path__ + "static/coronini_img4-edb188f2504a8e5fa538f5c59975c334.png";